import { useQuery } from "react-query";
import { useForm } from "react-hook-form";
import Radio from "src/components/Radio";
import { getStatements } from "src/models/fields";
import { setDefaultValues } from "src/utils";

const defaultValues = {
  ApplicationUserDefined12: "",
};

const MoreAboutYou = ({ id, data, onSubmit }) => {
  // Data loading
  const statements = useQuery("statements", () => getStatements(id));

  // Form
  const { register, handleSubmit, formState } = useForm({
    mode: "all",
    defaultValues: setDefaultValues(defaultValues, data),
  });
  const { errors, isSubmitting } = formState;

  return (
    <>
      <h2>More About You</h2>

      <form onSubmit={handleSubmit(onSubmit)}>
        {statements.isLoading ? (
          <p>Loading...</p>
        ) : (
          <Radio
            label="What statement best describes you?"
            name="ApplicationUserDefined12"
            options={statements?.data || []}
            register={register}
            validation={{ required: "Please select a statement" }}
            error={errors.ApplicationUserDefined12}
          />
        )}

        <button type="submit" className="form-submit" disabled={isSubmitting}>
          {isSubmitting ? "Saving" : "Next"}
        </button>
      </form>
    </>
  );
};

export default MoreAboutYou;
